// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3sjSV","colCheckbox":"styles_colCheckbox__JMzOO"};